/**
 * CacheVersion — localStorage cache invalidation via version bump.
 *
 * Refs #617
 *
 * Context: de `af_offline_*` keys in localStorage worden gevuld via
 * setLocalData() in services/api/base.ts en bevatten gecachte domain
 * data (people, relationships, sources, etc.). Deze cache heeft geen
 * TTL en geen versie-check, waardoor browsers pre-migratie data
 * kunnen blijven gebruiken na een data-model wijziging.
 *
 * Deze service checkt bij app-startup of de lokale cacheversie
 * gelijk is aan de huidige CACHE_VERSION. Zo niet, worden ALLEEN de
 * `af_offline_*` keys gewist — auth (`af_user`), theme, sidebar-state,
 * tree-state en de OfflineQueue blijven ongemoeid.
 *
 * Bump CACHE_VERSION wanneer:
 *   - Een migratie het format van gecachte data wijzigt
 *   - Legacy data wordt opgeruimd die nog in clients kan leven
 */

const CACHE_VERSION = 2;
const VERSION_KEY = 'af_cache_version';
const OFFLINE_PREFIX = 'af_offline_';

export const checkAndBumpCacheVersion = (): void => {
  try {
    const stored = parseInt(localStorage.getItem(VERSION_KEY) || '0', 10);
    if (stored >= CACHE_VERSION) return;

    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(OFFLINE_PREFIX)) keysToRemove.push(key);
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
    localStorage.setItem(VERSION_KEY, String(CACHE_VERSION));

    console.info(
      `[CacheVersion] Bumped ${stored} → ${CACHE_VERSION}, cleared ${keysToRemove.length} cached entries`
    );
  } catch (err) {
    console.warn('[CacheVersion] Failed to check cache version:', err);
  }
};
